import React from 'react';
import { motion } from 'framer-motion';
export function ClosingSection() {
  return <section id="checkout" className="py-16 md:py-32 px-5 md:px-6 bg-gradient-to-b from-[#0a0e1a] to-[#05070d] text-center scroll-mt-8" data-id="element-10">
      <div className="max-w-3xl mx-auto" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.2
      }} className="space-y-8 md:space-y-12 mb-12 md:mb-20" data-id="element-12">
          <h2 className="text-3xl md:text-5xl font-playfair text-[#f5f0e8]" data-id="element-13">
            The quiet promise
          </h2>

          <div className="space-y-4 md:space-y-6" data-id="element-14">
            <p className="text-xl md:text-2xl text-[#e8e0d4]" data-id="element-15">
              You don't need to win sleep.
            </p>
            <p className="text-xl md:text-2xl text-[#c9a96e] font-playfair italic" data-id="element-16">
              You just need to stop feeding the loop.
            </p>
          </div>

          <div className="space-y-5 md:space-y-8 py-4 md:py-8" data-id="element-17">
            <p className="text-base md:text-xl text-[#8b8178] font-light" data-id="element-18">
              The first time you wake up and don't do the time math…
            </p>
            <p className="text-base md:text-xl text-[#8b8178] font-light" data-id="element-19">
              the first time you feel the urge to Google and you don't…
            </p>
            <p className="text-base md:text-xl text-[#e8e0d4] font-medium" data-id="element-20">
              the first time you realize "I'm allowed to be awake" and your body
              drops…
            </p>
          </div>

          <p className="text-2xl md:text-4xl font-playfair text-[#f5f0e8]" data-id="element-21">
            That's the beginning of the reset.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-4 md:space-y-6" data-id="element-22">
          <div className="mb-3 md:mb-4" data-id="element-23">
            <div className="flex items-center justify-center gap-3 md:gap-4 mb-2" data-id="element-24">
              <span className="text-xl md:text-2xl text-[#8b8178] line-through opacity-60" data-id="element-25">
                €28.90
              </span>
              <span className="bg-[#c9a96e]/20 text-[#c9a96e] text-xs md:text-sm font-bold px-2.5 py-0.5 md:px-3 md:py-1 rounded-full uppercase tracking-wider" data-id="element-26">
                78% off
              </span>
            </div>
            <p className="text-4xl md:text-6xl font-bold text-[#f5f0e8] font-playfair" data-id="element-27">
              €6.36
            </p>
            <p className="text-[#8b8178] text-xs md:text-sm mt-1.5 md:mt-2" data-id="element-28">
              One-time payment · Instant PDF download
            </p>
          </div>

          <a href="https://plenava.com/cart/52395527766363id1:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-[#c9a96e] hover:bg-[#d4b87a] text-[#0a0e1a] px-8 py-5 md:px-10 md:py-6 rounded-lg font-bold text-lg md:text-2xl transition-all duration-300 shadow-[0_0_30px_rgba(201,169,110,0.3)] hover:shadow-[0_0_50px_rgba(201,169,110,0.5)] transform hover:-translate-y-1" data-id="element-29">
            Get The 3AM Loop Breaker (7-Day Reset) Now
          </a>

          <p className="text-[#8b8178] italic text-base md:text-lg mt-3 md:mt-4" data-id="element-30">
            And tonight—when it happens—open the page that tells you exactly
            what to do in the first 120 seconds.
          </p>
        </motion.div>
      </div>
    </section>;
}